<div class="section-wrapper">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroBell'" [size]="'24px'" [color]="'#822AC6'" [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">
      {{ 'ACCOUNT.NOTIFICATIONS.CALL_NOTIFICATIONS' | translate }}
    </div>
  </div>
  <div class="section-info">
    <img class="icon" [src]="'assets/images/info-icon-circle.svg'">
    <span class="text">{{'ACCOUNT.NOTIFICATIONS.NOTIFICATIONS_DESCRIPTION' | translate}}</span>
  </div>
  <div class="section-content-wrapper pb-4">
    <div class="d-flex justify-content-between align-items-start">
      <div class="notifications-wrapper">
        <div class="section-content-label">{{ 'ACCOUNT.NOTIFICATIONS.EMAIL_NOTIFICATIONS' | translate }}</div>
      </div>
      <rosie-switch [control]="callNotifications?.get('emailNotificationEnabled')"
        class="notification-switch"></rosie-switch>
    </div>
  </div>
  <div class="section-content-wrapper pt-0" *ngIf="callNotifications?.get('emailNotificationEnabled')?.value">
    <div class="section-action-header" [ngClass]="{'with-items': emails?.controls?.length > 0}">
      <div class="section-action-header-label">{{ 'ACCOUNT.NOTIFICATIONS.EMAIL_ADDRESS' | translate }}</div>
      <rosie-button [customClass]="'action narrow slimmer text-sm'" [translationKey]="'COMMON.ADD'"
        [iconPrefixConfig]="{name: 'heroPlus', size: '18px', strokeWidth: '2', color: '#822ac6'}"
        (click)="handleNotification(null,CallFinishedNotificationChannel.Email)"></rosie-button>
    </div>
    <div class="section-list-item-wrapper with-action-header" *ngIf="emails?.controls?.length > 0">
      <div *ngFor="let email of emails?.controls; let last = last; let i = index;" class="section-list-item"
        [ngClass]="{'last': last}">
        <div>
          <div class="text">{{email?.get('destination')?.value}}</div>
          <div class="d-flex align-items-center"><ng-container
              *ngFor="let conversationType of email?.get('configuration')?.get('callTypes')?.controls; let first = first;"><span
                class="subtext-item" *ngIf="conversationType.value.isEnabled"><span *ngIf="!first"
                  class="subtext-item-dot">•</span>{{ conversationType.value.label }}</span></ng-container>
          </div>
        </div>
        <div class="section-list-icons">
          <div class="icon"><ng-icon [name]="'heroPencilSquare'" [color]="'#6C6176'" [size]="'20px'"
              (click)="handleNotification(i, CallFinishedNotificationChannel.Email)"></ng-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="separator full my-0"></div>
  <div class="section-content-wrapper">
    <div class="d-flex justify-content-between align-items-start">
      <div class="notifications-wrapper">
        <div class="section-content-label">{{ 'ACCOUNT.NOTIFICATIONS.TEXT_NOTIFICATIONS' | translate }}</div>
      </div>
      <rosie-switch [control]=" callNotifications?.get('smsNotificationEnabled')"
        class="notification-switch"></rosie-switch>
    </div>
  </div>
  <div class="section-content-wrapper pt-0" *ngIf="callNotifications?.get('smsNotificationEnabled')?.value">
    <div class="section-action-header" [ngClass]="{'with-items': phoneNumbers?.controls?.length > 0}">
      <div class="section-action-header-label">{{ 'ACCOUNT.NOTIFICATIONS.MOBILE_NUMBER' | translate }}</div>
      <rosie-button [customClass]="'action narrow slimmer text-sm'" [translationKey]="'COMMON.ADD'"
        [iconPrefixConfig]="{name: 'heroPlus', size: '18px', strokeWidth: '2', color: '#822ac6'}"
        (click)="handleNotification(null,CallFinishedNotificationChannel.SMS)"></rosie-button>
    </div>
    <div class="section-list-item-wrapper with-action-header" *ngIf="phoneNumbers?.controls?.length > 0">
      <div *ngFor="let number of phoneNumbers?.controls; let last = last; let i = index;" class="section-list-item"
        [ngClass]="{'last': last}">
        <div>
          <div class="text">{{number?.get('destination')?.value | phoneNumber}}</div>
          <div class="d-flex align-items-center"><ng-container
              *ngFor="let conversationType of number?.get('configuration')?.get('callTypes')?.controls; let first = first;"><span
                class="subtext-item" *ngIf="conversationType.value.isEnabled"><span *ngIf="!first"
                  class="subtext-item-dot">•</span>{{ conversationType.value.label }} </span></ng-container>
          </div>
        </div>
        <div class="section-list-icons">
          <div class="icon"><ng-icon [name]="'heroPencilSquare'" [color]="'#6C6176'" [size]="'20px'"
              (click)="handleNotification(i, CallFinishedNotificationChannel.SMS)"></ng-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isProduction">
    <div class="separator full my-0"></div>
    <div class="section-content-wrapper">
      <div class="d-flex justify-content-between align-items-start">
        <div class="notifications-wrapper">
          <div class="section-content-label">{{ 'ACCOUNT.NOTIFICATIONS.PUSH_NOTIFICATIONS' | translate }}</div>
          <div class="section-content-sublabel">{{ 'ACCOUNT.NOTIFICATIONS.PUSH_NOTIFICATIONS_DESCRIPTION' | translate }}</div>
        </div>
        <rosie-switch [control]="callNotifications?.get('pushNotificationEnabled')"
          class="notification-switch"></rosie-switch>
      </div>
    </div>
    <div class="section-content-wrapper pt-0" *ngIf="callNotifications?.get('pushNotificationEnabled')?.value">
      <div class="section-action-header">
        <div class="section-action-header-label">{{ 'ACCOUNT.NOTIFICATIONS.CALL_TYPES' | translate }}</div>
        <rosie-button [customClass]="'action narrow slimmer text-sm'" [translationKey]="'COMMON.EDIT'"
          [iconPrefixConfig]="{name: 'heroPencilSquare', size: '18px', strokeWidth: '2', color: '#822ac6'}"
          (click)="openPushNotificationModal()"></rosie-button>
      </div>
      <div class="section-list-item-wrapper with-action-header">
        <div class="section-list-item last">
          <div class="d-flex align-items-center">
            <ng-container *ngFor="let callType of pushCallTypes?.controls; let first = first;">
              <span class="subtext-item" *ngIf="callType.value.isEnabled">
                <span *ngIf="!first" class="subtext-item-dot">•</span>{{ callType.value.label }}
              </span>
            </ng-container>
            <span class="subtext-item" *ngIf="!hasPushCallTypesEnabled()">No call types selected</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<ngx-smart-modal #notificationModal disableRefocus identifier="notificationModal" [customClass]="'notification-modal'">
  <div class="modal-title with-subtitle">
    {{ 'ACCOUNT.NOTIFICATIONS.EDIT_NOTIFICATIONS' | translate}}
  </div>
  <div class="modal-subtitle with-border"></div>
  <div class="modal-content">
    <div class="section-item-wrapper justify-content-between mb-0">
      <div class="section-item-label">{{ 'ACCOUNT.NOTIFICATIONS.SEND_NOTIFICATION_TO' | translate:{value:
        selectedNotificationItem?.type === CallFinishedNotificationChannel.Email ? 'Email': 'Phone number'} }}</div>
      <div class="w-100">
        <ng-container *ngIf="selectedNotificationItem?.type === CallFinishedNotificationChannel.Email">
          <rosie-text [control]="selectedNotificationItem.control?.get('destination')"
            [placeholderTranslationKey]="'ACCOUNT.NOTIFICATIONS.TYPE_EMAIL'" [lowercaseOnly]="true"></rosie-text>
          <rosie-validation-error
            [show]="selectedNotificationItem.control?.get('destination')?.errors?.email && selectedNotificationItem.control?.get('destination')?.touched"
            [translationKey]="'COMMON.VALIDATION.PATTERN'"
            [translationAttributes]="{value: 'Email'}"></rosie-validation-error>
          <rosie-validation-error
            [show]="selectedNotificationItem.control?.get('destination')?.errors?.required && selectedNotificationItem.control?.get('destination')?.touched"
            [translationKey]="'COMMON.VALIDATION.REQUIRED'"
            [translationAttributes]="{value: 'Email'}"></rosie-validation-error>
        </ng-container>
        <ng-container *ngIf="selectedNotificationItem?.type === CallFinishedNotificationChannel.SMS">
          <rosie-phone [control]="selectedNotificationItem.control?.get('destination')"
            [placeholderTranslationKey]="'ACCOUNT.NOTIFICATIONS.TYPE_NUMBER'"></rosie-phone>
          <rosie-validation-error
            [show]="selectedNotificationItem.control?.get('destination')?.errors?.required && selectedNotificationItem.control?.get('destination')?.touched"
            [translationKey]="'COMMON.VALIDATION.REQUIRED'"
            [translationAttributes]="{value: 'Phone number'}"></rosie-validation-error>
        </ng-container>
      </div>
    </div>
    <rosie-alert class="d-block mt-4" [customClass]="'mb-0'"
      *ngIf="selectedNotificationItem?.control?.errors?.duplicate && !!selectedNotificationItem?.control?.get('destination')?.value"
      [message]="('COMMON.VALIDATION.DUPLICATE' | translate:{value: selectedNotificationItem?.type === CallFinishedNotificationChannel.Email ? 'Email': 'Phone number'} )">
    </rosie-alert>
  </div>
  <div class="separator full"></div>
  <div class="modal-content">
    <div class="section-item-wrapper">
      <div class="section-item-labels">
        <div class="section-item-label">{{'ACCOUNT.NOTIFICATIONS.NOTIFICATIONS' | translate}}</div>
        <div class="section-item-sublabel">{{'ACCOUNT.NOTIFICATIONS.NOTIFICATIONS_DESCRIPTION_LONG' | translate}}</div>
      </div>
    </div>
    <div class="section-item-wrapper justify-content-between" [ngClass]="{'mb-0': last}"
      *ngFor="let notification of selectedNotificationItem?.control?.get('configuration')?.get('callTypes')?.controls; let last = last; let i = index;">
      <ng-container *ngIf="notification.get('value').value !== 'en'">
        <div class="section-item-label">{{ notification.get('label')?.value }}</div>
        <rosie-switch [control]="notification.get('isEnabled')" class="d-flex">
        </rosie-switch>
      </ng-container>
    </div>
  </div>
  <div class="modal-action-line with-border"
    [ngClass]="{'with-delete-action': isEditingExistingItem, 'delete-confirmation': removeActionInProgress}">
    <ng-container *ngIf="!removeActionInProgress">
      <ng-container *ngIf="isEditingExistingItem">
        <rosie-button [customClass]="'narrow slim text-sm secondary destructive'" [translationKey]="'COMMON.DELETE'"
          [iconPrefixConfig]="{name: 'heroTrash', size: '18px', strokeWidth: '2', color: '#6C6176', hoverColor: '#9F1239'}"
          (click)="handleItemRemoveAction()"></rosie-button>
      </ng-container>
      <div class="d-flex align-items-center gap-2">
        <rosie-button (click)="notificationModal.close()" class="d-block" [customClass]="'secondary narrow'"
          [translationKey]="'COMMON.CANCEL'">
        </rosie-button>
        <rosie-button (click)="handleNotificationChangeSave()" class="d-block" [customClass]="'narrow slim'"
          [translationKey]="'COMMON.SAVE'">
        </rosie-button>
      </div>
    </ng-container>
    <ng-container *ngIf="removeActionInProgress">
      <div class="destructive-wrapper">
        <div class="destructive-icon"><ng-icon [name]="'heroExclamationTriangleSolid'" [color]="'#BE123C'"
            [size]="'20px'" (click)="handleItem(i)"></ng-icon>
        </div>
        <div class="destructive-text">{{ 'COMMON.PERMANENTLY_DELETE' | translate }}</div>
      </div>
      <div class="d-flex align-items-center gap-2">
        <rosie-button (click)="handleItemRemoveCancel()" class="d-block" [customClass]="'secondary narrow'"
          [translationKey]="'COMMON.CANCEL'">
        </rosie-button>
        <rosie-button (click)="removeItem()" class="d-block" [customClass]="'narrow slim danger'"
          [translationKey]="'COMMON.YES_DELETE'">
        </rosie-button>
      </div>
    </ng-container>
  </div>
</ngx-smart-modal>
<ngx-smart-modal #pushNotificationModal disableRefocus identifier="pushNotificationModal" [customClass]="'notification-modal'">
  <div class="modal-title with-subtitle">
    {{ 'ACCOUNT.NOTIFICATIONS.NOTIFICATIONS' | translate}}
  </div>
  <div class="modal-subtitle with-border">{{ 'ACCOUNT.NOTIFICATIONS.NOTIFICATIONS_DESCRIPTION_LONG' | translate }}</div>
  <div class="modal-content">
    <div class="section-item-wrapper justify-content-between" [ngClass]="{'mb-0': last}"
      *ngFor="let notification of pushCallTypes?.controls; let last = last; let i = index;">
      <div class="section-item-label">{{ notification.get('label')?.value }}</div>
      <rosie-switch [control]="notification.get('isEnabled')" class="d-flex">
      </rosie-switch>
    </div>
  </div>
  <div class="modal-action-line with-border">
    <div class="d-flex align-items-center gap-2">
      <rosie-button (click)="pushNotificationModal.close()" class="d-block" [customClass]="'secondary narrow'"
        [translationKey]="'COMMON.CANCEL'">
      </rosie-button>
      <rosie-button (click)="pushNotificationModal.close()" class="d-block" [customClass]="'narrow slim'"
        [translationKey]="'COMMON.SAVE'">
      </rosie-button>
    </div>
  </div>
</ngx-smart-modal>